/**
 * Build-time configuration injected via esbuild define.
 * All values are sourced from .env.frontend at build time.
 */
export const config = {
  /** Base URL for the DelegatedDNS API */
  apiBaseUrl: process.env.APP_API_BASE_URL ?? '/api',

  /** EntraID OAuth2 tenant ID */
  entraIdTenantId: process.env.APP_ENTRAID_TENANT_ID ?? '',

  /** EntraID OAuth2 client ID */
  entraIdClientId: process.env.APP_ENTRAID_CLIENT_ID ?? '',

  /** EntraID OAuth2 redirect URI (this app's callback URL) */
  entraIdRedirectUri: process.env.APP_ENTRAID_REDIRECT_URI ?? `${window.location.origin}/callback`,

  /** EntraID OAuth2 scopes */
  entraIdScopes: process.env.APP_ENTRAID_SCOPES ?? 'openid profile email',

  /** Session timeout in milliseconds (30 minutes) */
  sessionTimeoutMs: 30 * 60 * 1000,
} as const;
